import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import QuestionCircle from '@deliveroo/icon-set/react/QuestionCircle';
import Icon from '@deliveroo/consumer-component-library/components/Icon';

import OrderShareModalButtonContainer from '../OrderShareModalButton';

import i18n from '../../utils/i18n';
import OrderStatusProgress from '../../components/OrderStatusProgress';

import { isFeatureActive } from '../../selectors/configSelectors';
import { CP_OT_HIDE_PROGRESS_ANIMATION, CX_OT_CANCEL_ORDER } from '../../flags/features';

import styles from './styles.scss';

export function OrderStatusProgressContainer(props) {
  const {
    attributes,
    isPollingAndUnderPollLimit,
    isOverPollLimit,
    orderId,
    hasStatusButton,
    isSharedOrder,
    orderTrackerProgressAnimationFeatureOn,
  } = props;

  const isNotFailedStatus = attributes && attributes.uiStatus !== 'FAILED';
  const showFormattedSuccessMessage = attributes && attributes.uiStatus === 'COMPLETED';

  return (
    <Fragment>
      {!isSharedOrder && (
        <div className={styles['order-actions-container']}>
          <OrderShareModalButtonContainer mobileView />
          <a
            className={styles['help-link']}
            href={`/orders/${orderId}/help?redirectTo=/orders/${orderId}/status`}
            aria-label={i18n.gettext('order_status_page.order_help')}
            title={i18n.gettext('order_status_page.order_help')}
          >
            <Icon component={QuestionCircle} size={24} />
          </a>
        </div>
      )}
      <OrderStatusProgress
        attributes={attributes}
        isNotFailedStatus={isNotFailedStatus}
        isPollingAndUnderPollLimit={isPollingAndUnderPollLimit}
        isOverPollLimit={isOverPollLimit}
        orderTrackerProgressAnimationFeatureOn={orderTrackerProgressAnimationFeatureOn}
        showFormattedSuccessMessage={showFormattedSuccessMessage}
        hasStatusButton={hasStatusButton}
      />
    </Fragment>
  );
}

OrderStatusProgressContainer.defaultProps = {
  isPollingAndUnderPollLimit: false,
  isOverPollLimit: false,
  hasStatusButton: false,
  orderTrackerProgressAnimationFeatureOn: false,
  isSharedOrder: false,
};

OrderStatusProgressContainer.propTypes = {
  /** This is an object containing the attributes of the status */
  attributes: PropTypes.shape({
    currentProgressPercentage: PropTypes.number,
    etaMessage: PropTypes.string,
    formattedUpdatedAt: PropTypes.string.isRequired,
    message: PropTypes.string.isRequired,
    showLiveIndicator: PropTypes.bool.isRequired,
    title: PropTypes.string.isRequired,
    uiStatus: PropTypes.string.isRequired,
  }).isRequired,
  /** Whether the order has a button related to the status such as the cancel order button */
  hasStatusButton: PropTypes.bool,
  /**
   * Is polling occuring, if so is it under the poll limit
   * If order is not live this is false
   */
  isPollingAndUnderPollLimit: PropTypes.bool,
  /**
   * Has the number of times the order details have been called
   * greater than the poll limit
   */
  isOverPollLimit: PropTypes.bool,
  /** Id of the order */
  orderId: PropTypes.string.isRequired,
  /**
   * Show the order status progress animations
   * This is a feature variable
   */
  orderTrackerProgressAnimationFeatureOn: PropTypes.bool,
  /** If the order doesn't belong to the user but has been shared with them */
  isSharedOrder: PropTypes.bool,
};

export const mapStateToProps = (state) => {
  const { order, request } = state;
  const statusAttributes = order.status.attributes;
  const isSharedOrder = order.status.isSharedOrder;
  const orderTrackerCanceOrderOn = isFeatureActive(state, CX_OT_CANCEL_ORDER);

  return {
    // Get the orderId from the url query so we're not reliant on fetching the order
    orderId: request.currentQuery.orderId,
    attributes: statusAttributes,
    hasStatusButton:
      !isSharedOrder &&
      statusAttributes &&
      !!statusAttributes.statusButton &&
      orderTrackerCanceOrderOn,
    isSharedOrder,
    orderTrackerProgressAnimationFeatureOn: isFeatureActive(state, CP_OT_HIDE_PROGRESS_ANIMATION),
  };
};

export default connect(mapStateToProps)(OrderStatusProgressContainer);
